import { render } from "./CustomTestLevelsComponent.vue?vue&type=template&id=886c6a5c&lang=true"
import script from "./CustomTestLevelsComponent.vue?vue&type=script&lang=js"
export * from "./CustomTestLevelsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__